import { TrayFormViewModelType } from '../view-model-common/view-model-type';

// TODO: use TrayTypeApiModel here, when we have it on page version api
export const refactoredTrays = [
  TrayFormViewModelType.LiveTVReminders,
  TrayFormViewModelType.RecentlyPurchasedTray,
  TrayFormViewModelType.MixedSearchTagTray,
  TrayFormViewModelType.ExpiringStoreContents,
];
